import VisibilityToggle from "../../common/controls/tailwind-toggle";
import { useTranslate } from "../../locales/hooks";

interface IVisibilityTogglesProps {
  showAchievements: boolean;
  setShowAchievements: (value: boolean) => void;
  showResponsibilities: boolean;
  setShowResponsibilities: (value: boolean) => void;
  showProjects: boolean;
  setShowProjects: (value: boolean) => void;
}

const VisibilityToggles: React.FC<IVisibilityTogglesProps> = ({
  showAchievements,
  setShowAchievements,
  showResponsibilities,
  setShowResponsibilities,
  showProjects,
  setShowProjects,
}) => {
const t = useTranslate();
  return (
    <div className="flex flex-col gap-[8px] pb-[15px] mb-[10px] border-b border-[#e2e8f0]">
      <div className="flex gap-[5px]">
        <div className="w-[10px] shrink-0" />
        <p className="flex-1 font-['Inter',sans-serif] font-medium text-[13px] md:text-[9px] text-[#64748b] tracking-[-0.099px] leading-[1.5] mb-[4px]">
          {t('VisibilityToggles__HeaderLabel') || 'Show:'}
        </p>
      </div>

      {/* Achievements Toggle */}
      <VisibilityToggle
        onclick={() => setShowAchievements(!showAchievements)}
        isEnable={showAchievements}
        label={t('VisibilityToggles__AchievementsLabel') || 'Achievements'}
      />
      {/* Responsibilities Toggle */}
      <VisibilityToggle
        onclick={() => setShowResponsibilities(!showResponsibilities)}
        isEnable={showResponsibilities}
        label={t('VisibilityToggles__ResponsibilitiesLabel') || 'Responsibilities'}
      />
      {/* Projects Toggle */}
      <VisibilityToggle
        onclick={() => setShowProjects(!showProjects)}
        isEnable={showProjects}
        label={t('VisibilityToggles__ProjectsLabel') || 'Projects'}
      />
    </div>
  );
};

export default VisibilityToggles;

export type { IVisibilityTogglesProps };